import 'whatwg-fetch';

const API_ROOT = process.env.REACT_APP_API_ROOT;
const responseBody = res => res.json();

const opt = {};

const requests = {
  del: url =>
    window.fetch(`${API_ROOT}${url}`, Object.assign(opt, {
      method: 'DELETE'
    })).then(responseBody),
  get: url =>
    window.fetch(`${API_ROOT}${url}`, Object.assign(opt, {
      method: 'GET'
    })).then(responseBody),
  put: (url, body) =>
    window.fetch(`${API_ROOT}${url}`, Object.assign(opt, {
      method: 'PUT',
      body
    })).then(responseBody),
  post: (url, body) =>
    window.fetch(`${API_ROOT}${url}`, Object.assign(opt, {
      method: 'POST',
      body
    })).then(responseBody),
};

const FillWords = {
  get: slug =>
    requests.get(`/fillword/${slug}`),
  random: () =>
    requests.get(`/fillword/random?level=` + Math.round(Math.random() * 2)),
  success: () =>
    requests.post(`/fillword`)
};

export default {
  FillWords,
};